import styled from 'styled-components';
import { adjustColor } from '../../functions/primitiveHelpers/colorHelpers';
import THEME from '../../styles/colors';
import {
  boxModelStyles,
  fontStyles,
  IBoxModelStyleProps,
  IColorStyleProps,
  IFontStyleProps
} from '../../styles/css';

export type TAnchorStyleProps = IColorStyleProps &
  IFontStyleProps &
  IBoxModelStyleProps;

// eslint-disable-next-line prettier/prettier
export interface IStyledAnchorProps extends TAnchorStyleProps, React.HTMLProps<HTMLAnchorElement | HTMLButtonElement> {
  $underline?: boolean;
}

const StyledAnchor = styled.a.attrs<IStyledAnchorProps>(props => ({
  style: {
    '--data-color': props.$color ?? THEME.other.link ?? 'inherit',
    '--data-hover-color':
      props.$hoverColor ?? adjustColor(props.$color ?? THEME.other.link, -30)
  }
}))<IStyledAnchorProps>`
  appearance: none;
  background-color: transparent;
  text-decoration: ${({ $underline }) => ($underline ? 'underline' : 'none')};
  cursor: pointer;

  color: var(--data-color);
  :hover {
    color: var(--data-hover-color);
  }

  ${boxModelStyles}
  ${fontStyles}
`;

export default StyledAnchor;
